module.exports = __webpack_public_path__ + "img/neuronce-preview.0ab9f538.jpg";